import {KeyLabel} from '../../../../shared/domain/key-label.model';

export enum ReportType {
  STATISTICAL = 'STATISTICAL',
  FINANCIAL = 'FINANCIAL',
  DEMAND_PARTNER = 'DEMAND_PARTNER',
  PROMOCAST = 'PROMOCAST',

}

export const ReportTypeLabels = {
  STATISTICAL: 'Statistical',
  FINANCIAL: 'Financial',
  DEMAND_PARTNER: 'Demand partner',
};

export const ReportTypeKL = () =>
  (Object.keys(ReportTypeLabels).map(
      key => new KeyLabel<ReportType>(ReportType[key], ReportTypeLabels[key]))
  );
